<template>
  <default-modal :dialog="dialog" :expanded="modalExpanded" @close-dialog="onClose">
    <v-flex xs12 ml-5 mt-4 pb-2>
      <h6 class="title pt-2">{{title}}</h6>
    </v-flex>
    <user-form :inDialog="false"
                :mode="formMode"
                :isDark="true"
                :user="user"
                :company_id="company"
                @onUserCreate="onUserCreate"
                @onUserUpdate="onUserUpdate"
                @cancel="onClose"
                v-if="dialog" />
  </default-modal>
</template>

<script>
import DefaultRightModal from './DefaultRightModal'
import UsersForm from "../UsersForm"
import utils from '../shared/Utils'

export default {
  name: 'NewUserDialog',
  components: { 'default-modal': DefaultRightModal, 'user-form': UsersForm },
  props: {
    dialog: { type: Boolean },
    company: { type: String },
    user: { type: Object }
  },
  data(vm) {
    return {
      modalExpanded: false,
    }
  },
  computed: {
    title() {
      return (this.user === null) ? this.i18n('Novo Usuário') : this.i18n('Editar Usuário')
    },
    formMode() {
      return (this.user === null) ? 'insert' : 'update'
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    onClose() {
      this.modalExpanded = false
      this.$emit('close-dialog')
    },
    onUserCreate(created_user) {
      this.$root.$emit('userCreated', created_user)
      this.onClose()
    },
    onUserUpdate(updated_user) {
      this.$root.$emit('userUpdated', updated_user)
      this.onClose()
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/NewUserDialog.vue